import SelectBenchShapePage from '../components/SelectBenchShapePage';
import { connect } from 'react-redux';
import { changeShape,mirrorBench } from '../actions';
import localization from '../helpers/localization.js';
import { getWebpAwareExtension } from '../helpers/webpSupport';

const mapStateToProps = (state, ownProps) => {
    return {
        selections: buildShapes(state.benchModel.availableBenchShapes, state.benchModel.shape),
        unavailableSelections: buildUnavailableShapes(state.benchModel.unavailableBenchShapes || [], state.measurements),
        selected: state.benchModel.shape.code,
        showPrices: state.clientConfiguration.showPrices,
        prices: state.optionPricing.benchSpapes,
        selectionName: localization.selectBenchShape,
        mirrored: state.benchModel.mirrored,
        canMirrorBench: canMirrorBenchDirectly(state)
    };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
    onChange: (e) => {
        dispatch(changeShape(e));
    },
    mirrorBench: () => {
        dispatch(mirrorBench());       
    }
});

const SelectBenchShapePageContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(SelectBenchShapePage);

export default SelectBenchShapePageContainer;

let canMirrorBenchDirectly = (state) => {
    return state.clientConfiguration.benchMirrorBehavior === "by_mirroring_bench";
}
let currentShapes = {};


let buildShapes = (shapes, active) => {
    if (currentShapes.active !== active || !currentShapes.shapes || shapes.length !== currentShapes.shapes.length) {
        currentShapes.shapes = shapes.map(s => {
            return buildShapeSelection(s);
        }
        );
        currentShapes.active = active;
    }
    return currentShapes.shapes;
}

let buildUnavailableShapes = (shapes, measurements) => {
    return shapes.map(s => {
        return Object.assign({}, buildShapeSelection(s), {
            fitReason: buildFitReason(s, measurements)
        });
    });
}

let buildShapeSelection = (shape) => {
    return Object.assign({}, shape, {
        id: shape.code,
        thumbnail: "./img/shapes/" + shape.code + getWebpAwareExtension()
    });
}

let buildFitReason = (shape, measurements) => {
    let minimum = shape.mininimumSaunaSize;
    if (!minimum || !measurements) return "";
    return localization.minimumMeasurements + " " + minimum.width + "*" + minimum.depth + " mm.";
}
